import DateFormat from '@/shared/utils/date-format';

export default class PaymentFileFilter {
  customerCode?: string;

  customerTradingName?: string;

  customerName?: string;

  competence?: string;

  constructor(obj: any) {
    this.customerCode = obj.customerCode || '';
    this.customerTradingName = obj.customerTradingName || '';
    this.customerName = obj.customerName || '';
    this.competence = obj.competence || '';
  }

  public static of(obj: any) {
    return new PaymentFileFilter(obj || {})
  }

  public toRequest(): any {
    if (this.competence) {
      return { ...this, competence: `01/${DateFormat.localDateToLocal(this.competence)}` }
    }
    return this;
  }
}
